import { env } from 'app/lib/env';
import { type CioConfig, CioLogLevel, CioRegion, CustomerIO } from 'customerio-reactnative';
import { useEffect } from 'react';
import { log } from 'app/lib/monitoring';
import { isMobileNative } from 'app/utils/web-helpers';

// Import AnalyticsBrowser only on web platform; on native, it crashes the app!
import type { AnalyticsBrowser as CIOAB } from '@customerio/cdp-analytics-browser';
let AnalyticsBrowser: CIOAB | undefined;
let customerIOInitialized = false;
if (!isMobileNative) {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  AnalyticsBrowser = require('@customerio/cdp-analytics-browser').AnalyticsBrowser;
}

export const logoutCustomerIO = () => {
  if (globalThis.cioanalytics) {
    void globalThis.cioanalytics.reset();
  } else {
    void CustomerIO.clearIdentify();
  }
};

export const useCustomerIO = () => {
  useEffect(() => {
    if (customerIOInitialized) return;
    customerIOInitialized = true;

    if (!isMobileNative && AnalyticsBrowser) {
      globalThis.cioanalytics = AnalyticsBrowser.load({ writeKey: env.CUSTOMERIO_CDP_API_KEY });
      return;
    }

    const config: CioConfig = {
      cdpApiKey: env.CUSTOMERIO_CDP_API_KEY,
      migrationSiteId: env.CUSTOMERIO_SITE_ID,
      inApp: {
        siteId: env.CUSTOMERIO_SITE_ID,
      },
      region: CioRegion.US,
      logLevel: CioLogLevel.Info,
      // trackApplicationLifecycleEvents: true, // Default to ON
      // autoTrackDeviceAttributes: true, // Default to ON
    };

    // Was trying to debug what is happening in PROD with customer.io, so using logLevel = debug in PROD too, for now
    // Ref: https://lepartageclub.atlassian.net/browse/LPC-1109
    // config.logLevel = CioLogLevel.Debug;

    log(`[CustomerIO.initialize] [config]: ${JSON.stringify([config])}`);
    void CustomerIO.initialize(config);
  }, []);
};
